"use client";

import Image from "next/image";
import Link from "next/link";

export default function PromotionalBanner() {
  return null;
}
